module.exports = __webpack_public_path__ + "img/jewelry@2x.213e5b1.png";